<div #header mat-dialog-title>
  Legend
</div>

<mat-dialog-content style="padding-top: 10px !important;">
  <div style="width:100%;display: inline-block;">
    <div style="padding:5px 10px 5px 10px;display: inline-block;">
      <div 
        style="background-color: #afbe73; height: 30px; width: 30px; display: inline-block; vertical-align: middle; font-size: 22px; text-align: center; ">C
      </div>
      &nbsp;&nbsp;
      <span>Comment exists for this period or day</span>
    </div>
  </div>

  <div style="width:100%;display: inline-block;padding-top: 10px;">
    <div style="padding:5px 10px 5px 10px;display: inline-block;">
      <div 
        style="background-color: #a20000; height: 30px; width: 30px; display: inline-block; vertical-align: middle; font-size: 22px; text-align: center; ">A
      </div>
      &nbsp;&nbsp;
      <span>Attendance was marked by an administrator</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions #footer>
  <div class='flex-footer-right'>
    <tyl-button image="Cancel.png" label="Close" (click)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>